module.exports = __webpack_public_path__ + "static/media/heroSectionImage2.3be5f6f1.svg";